export default __webpack_public_path__ + "static/media/open-items-inactive.00b92ce2.svg";